// 枚举货币
const currencyEnum = {
  rmb: '人民币',
  usd: '美元',
  eur: '欧元',
  gbp: '英镑',
  jpy: '日元',
  hkd: '港币',
  twd: '新台币',
  "myr": "林吉特",
  krw: '韩元',
  sgd: '新加坡元',
}


export function priceFormat(priceInfo: {
  price: number,
  currency: string,
}) {
  const {price, currency} = priceInfo;
  // 千分位分隔符，保留两位小数，如果是整数，不显示小数
  const priceStr = price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  // currency小写
  const currencyStr = currencyEnum[currency?.toLowerCase()] || currencyEnum.rmb;
  return `${priceStr} ${currencyStr}`;
}

// TODO 服务端懒，不拼接数据，需要前端自己转换；懒人：墙翱
interface TestHistoryData {
  demand_id: number;
  permit_actions: {
    destroy: boolean;
    edit: boolean;
    demand_edit: boolean;
    plan_edit: boolean;
    discard: boolean;
    split: boolean;
    modify_quote: boolean;
    back_oa: boolean;
    close: boolean;
  };
  demand_suppliers: {
    id: number;
    demand_id: number;
    supplier_id: number;
    overall_score: number;
    is_quoted: boolean;
    is_self_contact: boolean;
    no_contract_flag: boolean;
    turns_number: number;
    created_at: string;
    updated_at: string;
    demand_supplier_quotes: {
      id: number;
      demand_supplier_id: number;
      cooperate_account_id: number;
      quote_price: number;
      currency: string;
      winning: boolean;
      translated_currency: string;
      created_at: string;
      updated_at: string;
    }[];
    bid_attachs: any[];
    supplier_full_name: string;
    supplier_short_name: string;
    go_next_round_journal: {
      operator: string;
      state: string;
      created_at: string;
    };
  }[];
  demand_plan_info: {
    id: number;
    demand_id: number;
    description: string;
    created_at: string;
    updated_at: string;
    translated_plan_type: string;
    category_names: string;
    // 合作内容列表
    cooperate_accounts: {
      id: number;
      demand_plan_info_id: number;
      account: string;
      remark: string;
      superior_resource_ships: {
        id: number;
        superior_resource_id: number;
        resourceable_type: string;
        resourceable_id: number;
        name: string;
      }[];
    }[];
    demand_planners: {
      id: number;
      user_id: number;
      demand_plan_info_id: number;
      user_name: string;
    }[];
    plan_attachs: any[];
    reference_attachs: any[];
    purchase_attachs: any[];
    member_business: any[];
    demand_quota_dtos: any[];
  };
}

type MPCHistoryList = {
  // 报价时间
  created_at: string;
  // 报价轮次
  turns_number: number;
  // 供应商比选方案附件
  quote_price_attachment_dtos: any[];

  // 合计报价
  total_quote_price: number;
  total_quote_price_currency: string;
  total_quote_price_show: string;

  quote_list: {
    // 合作id, , demand_plan_info.cooperate_accounts.id
    // demand_supplier_quotes
    cooperate_account_id: number;
    // 备注
    remark: string;
    // 合作内容,就是合作账号, demand_plan_info.cooperate_accounts.account
    cooperate_account: string;
    // 合作平台
    // demand_plan_info.cooperate_accounts.superior_resource_ships
    superior_resource_ships_name: string[];
    // 报价金额，demand_suppliers.demand_supplier_quotes.quote_price
    // 以 cooperate_account_id 为关联
    quote_price: number;
    // 报价币种
    currency: string;
    // 显示货币
    show_price: string;
  }[];
}[];


// 定义一个函数，将原始数据转换为所需的格式
export function MPCHistoryTransform(supperData: TestHistoryData): MPCHistoryList {
  // 从原始数据中解构出需求供应商和需求计划信息
  const { demand_suppliers, demand_plan_info } = supperData;
  // 从需求计划信息中解构出合作账户
  const { cooperate_accounts } = demand_plan_info;
  // 使用map函数将每个供应商的数据转换为所需的格式
  const res = demand_suppliers.map((supplier) => {
    const { demand_supplier_quotes, created_at } = supplier;
    // 使用map函数将每个报价转换为所需的格式
    const quote_list = demand_supplier_quotes.map((quote) => {
      // 从报价中解构出合作账户ID，报价价格和货币
      const { cooperate_account_id, quote_price, currency } = quote;
      // 在合作账户中找到与当前报价对应的账户
      const cooperate_account = cooperate_accounts.find(
        (item) => item.id === cooperate_account_id
      );
      // 返回转换后的报价数据
      return {
        cooperate_account_id,
        cooperate_account: cooperate_account?.account || '',
        superior_resource_ships_name: cooperate_account?.superior_resource_ships.map(
          (item) => item.name
        ),
        quote_price,
        currency,
        show_price: priceFormat({ price: quote_price, currency }),
        remark: cooperate_account?.remark || '',
      };
    });

    // 合计报价
    const total_quote_price = demand_supplier_quotes.reduce((total, quote) => {
      return total + quote.quote_price;
    }, 0);
    const total_quote_price_currency = demand_supplier_quotes[0]?.currency;
    const total_quote_price_show = priceFormat({
      price: total_quote_price,
      currency: total_quote_price_currency,
    });

    // 返回转换后的供应商数据
    return {
      created_at: created_at,
      overall_score: supplier.overall_score,
      turns_number: supplier.turns_number,
      quote_price_attachment_dtos: supplier.bid_attachs,
      total_quote_price,
      total_quote_price_currency,
      total_quote_price_show,
      quote_list,
    };
  });
  // 返回转换后的所有数据
  return res;
}
